<template>
  <div id="header-navigation-container" class="container-fluid">
    <b-navbar :toggleable="false" type="dark">

      <div class="col-1">
        <img src="@/assets/logo.png" width="100px">
      </div>

      <b-collapse id="header-navigation" is-nav>

        <b-nav-item-dropdown class="no-marker" v-for="(items, title) in header" :text="title" :key="title">
          <b-dropdown-item href="#" v-for="item in items" :key="item.path">
            <router-link :to="item.path">{{item.name}}</router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>

      </b-collapse>

      <b-nav-item-dropdown class="no-marker" v-if="user.isAdmin" text="Admin">
        <b-dropdown-item href="#">
          <router-link to="/admin/acl-management">ACL Management</router-link>
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown class="no-marker" id="header-navigation-account" text="My Account" right>
        <b-dropdown-item href="#">
          <router-link to="/dashboard-configuration">Dashboard Configuration</router-link>
        </b-dropdown-item>
        <hr>
        <b-dropdown-item href="#" @click="logOut">Log Out</b-dropdown-item>
      </b-nav-item-dropdown>

      <div v-if="user.isAdmin">
        <b-icon id="admin-settings" icon="gear-fill" @click="showPageAdministrationOverlay"></b-icon>
      </div>

    </b-navbar>
  </div>
</template>

<script>

import Vue from 'vue'
import PageAdministrationOverlay from '../administration/PageAdministrationOverlay'
import {mapGetters} from 'vuex'

export default {
  data () {
    return {}
  },
  methods: {
    showPageAdministrationOverlay () {
      const PageAdministrationOverlayClass = Vue.extend(PageAdministrationOverlay)
      const pageAdministrationOverlay = new PageAdministrationOverlayClass()
      pageAdministrationOverlay.$mount()
      const app = document.getElementById('app')
      app.appendChild(pageAdministrationOverlay.$el)
    },
    logOut () {
      this.$session.destroy()
      this.$router.push('/login')
    }
  },
  computed: mapGetters({
    user: 'getUser',
    header: 'getUserNavigation'
  }),
  beforeMount () {
    this.$store.dispatch('fetchUser', this.$session.get('loginId'))
    this.$store.dispatch('fetchCurrentPageId', this.$route.path)
    this.$store.dispatch('fetchUserNavigation', this.$session.get('loginId'))
  }
}
</script>

<style>
  #header-navigation-container {
    background: rgba(255,255,255,0.35)
  }
  #admin-settings {
    cursor: pointer;
  }
  .no-marker::marker {
    content: none !important;
  }
</style>
